import { Point } from '../../type/common.interface';

export function getFuncLine(x: number, point1: Point, point2: Point): number {
    const x1 = point1.x;
    const y1 = point1.y;
    const x2 = point2.x;
    const y2 = point2.y;

    // 计算斜率 m
    const m = (y2 - y1) / (x2 - x1);

    // 计算 y 轴截距 b
    const b = y1 - (m * x1);

    return (m * x) + b;
}
